import { gql } from '@apollo/client'

export const CREATE_TASK = gql`
  mutation CreateTask($payload: CreateTaskInput!) {
    createTask(payload: $payload) {
      id
    }
  }
`

export const UPDATE_TASK = gql`
  mutation UpdateTask($payload: UpdateTaskInput!) {
    updateTask(payload: $payload) {
      id
    }
  }
`

export const MARK_TASK_COMPLETED = gql`
  mutation MarkTaskCompleted($payload: MarkTaskCompletedInput!) {
    markTaskCompleted(payload: $payload) {
      id
    }
  }
`
